<template>
  <div class="patient-info__container">
    <div class="d-flex justify-content-end">
      <b-button v-b-modal.patient-info__modal class="w-100 text-nowrap btn-light font-weight-bold" type="button">
        Patient Info
      </b-button>
    </div>

    <b-modal id="patient-info__modal" :title="form.title" hide-footer hide-header-close>
      <div v-if="form.subtitle" class="mt-2 mb-4">
        <p>{{ form.subtitle }}</p>
      </div>

      <DynamicForm :form="form" :data="data" @cancel="hideModal" @submit="onSubmit" />
    </b-modal>
  </div>
</template>

<script>
import DynamicForm from "@/App/components/DynamicForm/DynamicForm";
import { CaseEvent, CaseUpdateEventType } from "@/Case/CaseEvent";

export default {
  components: { DynamicForm },

  props: {
    form: {
      type: Object,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    onSubmit({ data }) {
      this.$emit(CaseEvent.MODIFY, {
        eventType: CaseUpdateEventType.patientInfo,
        data: {
          formId: this.form.id,
          fields: data,
        },
      });
      this.hideModal();
    },
    hideModal() {
      this.$bvModal.hide("patient-info__modal");
    },
  },
};
</script>

<style>
.patient-info__container {
  flex: 2;
}
</style>
